import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
    dayWiseTimeLog: [],
    isLoadingDayWiseTimeLog: true,
    averageLoggedInHrs: [],
    isLoadingaverageLoggedInHrs: true,
    businessUnit: [],
    isLoadingBusinessUnit: true,
    locationWise: [],
    groupWise: [],
    designationWise: [],
    roleWise: [],
    teamWise: [],
    summaryCard: [],
    topApplication: [],
    isLoadingTopApp: true,
    topWebSite: [],
    topApplicationTimeSplit: [],
    isLoadingTopAppTimeSplit: true,
    topWebSiteTimeSplit: [],
    appWebsite: [],
    dailyInOut: [],
    isLoadingDailyInOut: true,
    inOutTime: [],
    isTeamWiseLoading:true,
    monthWiseTrend:[],
    isMonthwiseTrendLoading:true,
    weekWiseTrend:[],
    isWeekwiseTrendLoading:true
}
const reducer = (state = initialState, action) => {
    switch (action.type) {

        case types.SUCCESS_DATE_WISE_DISTRIBUTION:
            var data = action.data != undefined && action.data.map((i, index) => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                dayWiseTimeLog: data,
                isLoadingDayWiseTimeLog: false
            }
        case types.FAILED_DATE_WISE_DISTRIBUTION:
            return {
                ...state,
                dayWiseTimeLog: [],
                isLoadingDayWiseTimeLog: false
            }
        case types.SUCCESS_DATE_WISE_ACTIVE_PRODUCTIVE:
            var data = action.data != undefined && action.data.map(i => {

                return { date: i.date, workTime: i.workTime, productivity: i.productivity, loggedHrs: i.loggedHrs }
            })
            return {
                ...state,
                averageLoggedInHrs: data,
                isLoadingaverageLoggedInHrs: false
            }
        case types.FAILED_DATE_WISE_ACTIVE_PRODUCTIVE:
            return {
                ...state,
                averageLoggedInHrs: [],
                isLoadingaverageLoggedInHrs: false
            }
        case types.SUCCESS_BUSINESS_UNIT:
            var data = action.data != undefined && action.data.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                businessUnit: data,
                isLoadingBusinessUnit: false
            }
        case types.FAILED_BUSINESS_UNIT:
            return {
                ...state,
                businessUnit: [],
                isLoadingBusinessUnit: false
            }
        case types.SUCCESS_LOCATION_WISE:
            var data = action.data != undefined && action.data.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                locationWise: data,
            }
        case types.SUCCESS_DESIGNATION_WISE:
            var data = action.data != undefined && action.data.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                designationWise: data,
            }
        case types.SUCCESS_ROLE_WISE:
            var data = action.data != undefined && action.data.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                roleWise: data,
            }
        case types.SUCCESS_TEAM_WISE:
            var data = action.data.teamwiseProductivity != undefined && action.data.teamwiseProductivity.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                teamWise: data,
                isTeamWiseLoading:false
            }
            case types.FAILED_TEAM_WISE:
               
                return {
                    ...state,
                    teamWise: [],
                    isTeamWiseLoading:false
                }
        case types.SUCCESS_GROUP_WISE:
            var data = action.data != undefined && action.data.map(i => {
                return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, userCount: i?.usercount || 0, totalHors: i?.totalHr || 0 }
            })
            return {
                ...state,
                groupWise: data,
            }

        case types.SUCCESS_TOP_APPLICATION:
            var topApp = action.data.topComparison != undefined && action.data.topComparison.map(i => {
                return { name: i.application, value: parseFloat(i.workPer) }
            })
            var topWeb = action.data.topComparisonWeb != undefined && action.data.topComparisonWeb.map(i => {
                return { name: i.application, value: parseFloat(i.workPer) }
            })
            return {
                ...state,
                topApplication: topApp,
                topWebSite: topWeb,
                isLoadingTopApp: false
            }
        case types.FAILED_TOP_APPLICATION:
            return {
                ...state,
                topApplication: [],
                topWebSite: [],
                isLoadingTopApp: false
            }

        case types.SUCCESS_TOP_APP_TIME_SPLIT:
            if (action.data.topAppTimeSplit.length > 0) {
                return {
                    ...state,
                    topApplicationTimeSplit: [
                        {
                            ProductiveTime: parseFloat(action.data.topAppTimeSplit[0].prodPer),
                            UnProductiveTime: parseFloat(action.data.topAppTimeSplit[0].unProdPer),
                            IdleTime: parseFloat(action.data.topAppTimeSplit[0].idlePer)
                        }
                    ],
                    topWebSiteTimeSplit: [
                        {
                            ProductiveTime: parseFloat(action.data.topWebTimeSplit[0].prodPer),
                            UnProductiveTime: parseFloat(action.data.topWebTimeSplit[0].unProdPer),
                            IdleTime: parseFloat(action.data.topWebTimeSplit[0].idlePer),
                        }
                    ],
                    isLoadingTopAppTimeSplit: false
                }
            } else {
                return {
                    ...state,
                    topApplicationTimeSplit: [],
                    topWebSiteTimeSplit: [],
                    isLoadingTopAppTimeSplit: false
                }
            }
        case types.FAILED_TOP_APP_TIME_SPLIT:
            return {
                ...state,
                topApplicationTimeSplit: [],
                topWebSiteTimeSplit: [],
                isLoadingTopAppTimeSplit: false
            }
        case types.SUCCESS_TIME_SHEET_SUMMARY:
            var data = []
            if (action.data?.trakzoLiteUserCount) {
                data = [
                    {
                        name: 'Average Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 3,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 2,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 2,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.timeSheetUserCnt + "/" + action.data.noOfUsers,
                        unitAfter: '',
                        size: 1
                    },
                    {
                        name: 'TrakZo Lite User Count',
                        unitBefore: action.data?.trakzoLiteUserCount || "N.A",
                        unitAfter: '',
                        size: 2
                    },
                ]
            } else {
                data = [
                    {
                        name: 'Average Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 3,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 3,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 3,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.timeSheetUserCnt + "/" + action.data.noOfUsers,
                        unitAfter: '',
                        size: 1
                    },
                ]
            }

            return {
                ...state,
                summaryCard: data,
                appWebsite: [{
                    app: parseFloat(action.data.applicationHours.replace(":", ".")),
                    web: parseFloat(action.data.webHours.replace(":", ".")),
                }]
            }
        case types.SUCCESS_DASHBOARD_CARD:
            var data = []
            if (action.data?.trakzoLiteUserCount) {
                data = [
                    {
                        name: 'Average Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 2,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 2,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 2,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.noOfUsers,
                        unitAfter: '',
                        size: 2
                    },
                    {
                        name: 'TrakZo Lite User Count',
                        unitBefore: action.data?.trakzoLiteUserCount || "N.A",
                        unitAfter: '',
                        size: 2
                    },
                ]
            } else {
                data = [
                    {
                        name: 'Average Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 3,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 3,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Average Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 3,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.noOfUsers,
                        unitAfter: '',
                        size: 1
                    },
                ]
            }
            return {
                ...state,
                summaryCard: data,
                appWebsite: [{
                    app: parseFloat(action.data.applicationHours.replace(":", ".")),
                    web: parseFloat(action.data.webHours.replace(":", ".")),
                }]
            }
        case types.FAILED_DASHBOARD_CARD:
            return {
                ...state,
                summaryCard: [],
                appWebsite: []
            }
        case types.SUCCESS_DASHBOARD_CARD_SINGLE_DATE:
            var data = []
            if (action.data?.trakzoLiteUserCount) {
                data = [
                    {
                        name: 'Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 2,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 2,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 2,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.noOfUsers,
                        unitAfter: '',
                        size: 2
                    },
                    {
                        name: 'TrakZo Lite User Count',
                        unitBefore: action.data?.trakzoLiteUserCount || "N.A",
                        unitAfter: '',
                        size: 2
                    },
                ]
            } else {
                data = [
                    {
                        name: 'Capacity Hrs',
                        unitBefore: action.data.capacity.replace(":", "."),
                        unitAfter: '',
                        size: 2,
                        icon: "Clock",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Logged in Hrs',
                        unitBefore: action.data.deskTime.replace(":", "."),
                        unitAfter: action.data.avgLoggedInPer + "%",
                        size: 3,
                        icon: "In",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Active Hrs',
                        unitBefore: action.data.workingHours.replace(":", "."),
                        unitAfter: action.data.workingPercentage + "%",
                        size: 3,
                        icon: "User",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'Productive Hrs',
                        unitBefore: action.data.productiveHours.replace(":", "."),
                        unitAfter: action.data.productivePer + "%",
                        size: 3,
                        icon: "Clock2",
                        background: 'rgba(87,113,219,0.05)'
                    },
                    {
                        name: 'User Count',
                        unitBefore: action.data.noOfUsers,
                        unitAfter: '',
                        size: 1
                    }
                ]
            }
            return {
                ...state,
                summaryCard: data,
                appWebsite: [{
                    app: parseFloat(action.data.applicationHours.replace(":", ".")),
                    web: parseFloat(action.data.webHours.replace(":", ".")),
                }]
            }
        case types.FAILED_DASHBOARD_CARD_SINGLE_DATE:
            return {
                ...state,
                summaryCard: [],
                appWebsite: []
            }
        case types.SUCCESS_DAILY_IN_OUT:
            var data = action.data.attendanceInOut != undefined && action.data.attendanceInOut.map(i => {
                return { date: i.date, inTime: i.inTime, outTime: i.outTime }
            })
            return {
                ...state,
                dailyInOut: data,
                isLoadingDailyInOut: false,
                inOutTime: action.data.avgAttendanceInOut
            }
        case types.FAILED_DAILY_IN_OUT:
            return {
                ...state,
                dailyInOut: [],
                isLoadingDailyInOut: false,
                inOutTime: []
            }
            case types.SUCCESS_MONTH_WISE_DISTRIBUTION:
                var data = action.data != undefined && action.data.map((i, index) => {
                    return {  Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, totalHors: i?.totalHr || 0,month:i.month,monthYear:i.monthYear, userCount: i?.usercount  }
                })
                return {
                    ...state,
                    monthWiseTrend: data,
                    isMonthwiseTrendLoading: false
                }
            case types.FAILED_MONTH_WISE_DISTRIBUTION:
                return {
                    ...state,
                    monthWiseTrend: [],
                    isMonthwiseTrendLoading: false
                }
                case types.SUCCESS_WEEK_WISE_DISTRIBUTION:
                    var data = action.data != undefined && action.data.map((i, index) => {
                        return { date: i.date, Productive: i.productivity, Unproductive: i.unproductivity, IdleTime: i.idle, totalHors: i?.totalHr || 0, userCount: i?.usercount  }
                    })
                    return {
                        ...state,
                        weekWiseTrend: data,
                        isWeekwiseTrendLoading: false
                    }
                case types.FAILED_WEEK_WISE_DISTRIBUTION:
                    return {
                        ...state,
                        weekWiseTrend: [],
                        isWeekwiseTrendLoading: false
                    }
                  
        case types.SHOW_LOADER_EXECUTIVE_SUMMARY:
            return {
                ...state,
                dayWiseTimeLog: [],
                isLoadingDayWiseTimeLog: true,
                averageLoggedInHrs: [],
                isLoadingaverageLoggedInHrs: true,
                businessUnit: [],
                isLoadingBusinessUnit: true,
                locationWise: [],
                groupWise: [],
                designationWise: [],
                roleWise: [],
                teamWise: [],
                summaryCard: [],
                topApplication: [],
                isLoadingTopApp: true,
                topWebSite: [],
                topApplicationTimeSplit: [],
                isLoadingTopAppTimeSplit: true,
                topWebSiteTimeSplit: [],
                appWebsite: [],
                dailyInOut: [],
                isLoadingDailyInOut: true,
                inOutTime: [],
                isTeamWiseLoading:true,
                isMonthwiseTrendLoading:true,
                weekWiseTrend:[],
                isWeekwiseTrendLoading:true
            }
        default:
            return state
    }
}
export default reducer
